<template>
  <div>
    <!--SELECT : Dropdown select field.-->
    <v-select multiple v-model="selected" :options="options" :reduce="campaign => campaign.id" />
    <input type="hidden" :value="stringSelected" name="subscribing_campaigns" />

    <div class="step-spacer"></div>
  </div>
</template>

<script>
import utils from '../../../../mixins/utils';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {getSubscribingCampaigns} from '../../../../utility/api/campaign/getSubscribingCampaigns';

export default {
  name: 'subscribing-campaigns-piece',
  data() {
    return {
      options: [],
      selected: [],
    };
  },
  components: {vSelect},
  mixins: [utils],
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
    piece: {
      type: Object,
      required: true,
    },
    stepId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    stringSelected() {
      return this.selected.join(',');
    },
  },
  methods: {
    async getSubscribingCampaigns() {
      const {campaigns, selected_campaign_ids} = await getSubscribingCampaigns(this.campaignId, this.stepId);

      this.options = campaigns
        .map(({id, name}) => ({id, name, label: `${name} (ID: ${id})`}))
        .sort((a, b) => b.id - a.id);

      this.selected = selected_campaign_ids;
    },
  },
  created() {
    this.getSubscribingCampaigns();
  },
};
</script>

<style lang="scss">
.multiselect {
  height: 180px !important;
}
.vs__search,
.vs--open .vs__search {
  font-size: 20px;
}
</style>
